<mat-card class="cardWithShadow card-profile">
  <mat-card-content class="p-y-24">
    <mat-card-title>{{"change_password.change_password" | translate}}</mat-card-title>
    <mat-card-subtitle class="f-s-14">{{"change_password.to_change_password" | translate}}</mat-card-subtitle>

    <form class="m-t-24" [formGroup]="change_password_form" (ngSubmit)="onSubmit()">

      <mat-label class="f-s-14 f-w-600 d-block">{{"change_password.current_password" | translate}}</mat-label>
      <mat-form-field appearance="outline" class="w-100 hide-hint m-b-8" color="primary">
        <input matInput [type]="hideOldPassword ? 'password' : 'text'" formControlName="old_password" />
        <button mat-icon-button matSuffix type="button" class="password-toggle" (click)="hideOldPassword = !hideOldPassword"
                [attr.aria-label]="(hideOldPassword ? 'login.show_password' : 'login.hide_password') | translate"
                [attr.aria-pressed]="!hideOldPassword">
          <i-tabler [name]="hideOldPassword ? 'eye' : 'eye-off'" class="icon-18"></i-tabler>
        </button>
        <mat-error *ngIf="change_password_form.get('old_password')?.hasError('required') && change_password_form.get('old_password')?.touched">
          {{ 'login.password_required' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-label class="f-s-14 f-w-600 d-block m-t-8">{{"change_password.new_password" | translate}}</mat-label>
      <mat-form-field appearance="outline" class="w-100 hide-hint m-b-8" color="primary">
        <input matInput [type]="hideNewPassword ? 'password' : 'text'" formControlName="new_password" />
        <button mat-icon-button matSuffix type="button" class="password-toggle" (click)="hideNewPassword = !hideNewPassword"
                [attr.aria-label]="(hideNewPassword ? 'login.show_password' : 'login.hide_password') | translate"
                [attr.aria-pressed]="!hideNewPassword">
          <i-tabler [name]="hideNewPassword ? 'eye' : 'eye-off'" class="icon-18"></i-tabler>
        </button>
      </mat-form-field>
      <mat-error class="mat-mdc-form-field-subscript-wrapper p-l-16" *ngIf="change_password_form.get('new_password')?.hasError('required') && change_password_form.get('new_password')?.touched">
        {{ 'login.password_required' | translate }}
      </mat-error>
      <mat-error class="mat-mdc-form-field-subscript-wrapper p-l-16" *ngIf="change_password_form.get('new_password')?.hasError('minlength') && change_password_form.get('new_password')?.touched">
        {{ 'recovery_password.password_min_length' | translate: { minLength: passwordMinLength } }}
      </mat-error>
      <ng-container *ngIf="change_password_form.get('new_password')?.hasError('passwordStrength') && change_password_form.get('new_password')?.touched">
        <mat-error class="mat-mdc-form-field-subscript-wrapper p-l-16" *ngIf="!change_password_form.get('new_password')?.getError('passwordStrength')?.hasUpperCase">
          {{ 'change_password.password_requires_uppercase' | translate }}
        </mat-error>
        <mat-error class="mat-mdc-form-field-subscript-wrapper p-l-16" *ngIf="!change_password_form.get('new_password')?.getError('passwordStrength')?.hasLowerCase">
          {{ 'change_password.password_requires_lowercase' | translate }}
        </mat-error>
        <mat-error class="mat-mdc-form-field-subscript-wrapper p-l-16" *ngIf="!change_password_form.get('new_password')?.getError('passwordStrength')?.hasNumber">
          {{ 'change_password.password_requires_number' | translate }}
        </mat-error>
        <mat-error class="mat-mdc-form-field-subscript-wrapper p-l-16" *ngIf="!change_password_form.get('new_password')?.getError('passwordStrength')?.hasSpecialChar">
          {{ 'change_password.password_requires_special' | translate }}
        </mat-error>
      </ng-container>

      <mat-label class="f-s-14 f-w-600 d-block m-t-8">{{"change_password.confirm_password" | translate}}</mat-label>
      <mat-form-field appearance="outline" class="w-100 hide-hint m-b-8" color="primary">
        <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirm_new_password" />
        <button mat-icon-button matSuffix type="button" class="password-toggle" (click)="hideConfirmPassword = !hideConfirmPassword"
                [attr.aria-label]="(hideConfirmPassword ? 'login.show_password' : 'login.hide_password') | translate"
                [attr.aria-pressed]="!hideConfirmPassword">
          <i-tabler [name]="hideConfirmPassword ? 'eye' : 'eye-off'" class="icon-18"></i-tabler>
        </button>
      </mat-form-field>

      <mat-error class="mat-mdc-form-field-subscript-wrapper p-l-16" *ngIf="change_password_form.get('confirm_new_password')?.hasError('required') && change_password_form.get('confirm_new_password')?.touched">
        {{ 'login.password_required' | translate }}
      </mat-error>

      <mat-error class="mat-mdc-form-field-subscript-wrapper p-l-16 m-b-8" *ngIf="change_password_form.hasError('passwordMismatch') && change_password_form.touched">
        {{ 'recovery_password.passwords_dont_match' | translate }}
      </mat-error>

      <button mat-flat-button color="primary" class="w-100 m-t-16" [disabled]="!change_password_form.valid">
        {{"change_password.change_password" | translate}}
      </button>
    </form>

  </mat-card-content>
</mat-card>
